import * as actionTypes from '../actions/actionTypes';
import STATUS from '../actions/constants';

const initialState = {
  status: STATUS.IDLE,
  error: null,
  services: [],
  service: null,
};

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SERVICES_INIT:
      return {
        ...state,
        status: STATUS.LOADING,
        error: null,
      };
    case actionTypes.GET_SERVICES_SUCCESS:
      return {
        ...state,
        status: STATUS.SUCCEEDED,
        services: action.payload,
        error: null,
      };
    case actionTypes.GET_SERVICES_ERROR:
      return {
        ...state,
        status: STATUS.FAILED,
        error: action.payload,
      };
    case actionTypes.GET_SERVICE_INIT:
      return {
        ...state,
        status: STATUS.LOADING,
        error: null,
        service: null,
      };
    case actionTypes.GET_SERVICE_SUCCESS:
      return {
        ...state,
        status: STATUS.SUCCEEDED,
        service: action.payload,
        error: null,
      };
    case actionTypes.GET_SERVICE_ERROR:
      return {
        ...state,
        status: STATUS.FAILED,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default serviceReducer;
